import { Box } from "@mui/material";
import styled from "styled-components";
import theme from "../../theme/theme";

export const ModalBox = styled(Box)`
  font-family: "Inter", sans-serif;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  height: auto;
  background-color: ${theme.color.pearl};
  border-radius: 20px;
  box-shadow: 24px;

  @media (max-width: 1024px) {
    width: 60%;
  }

  @media (max-width: 767px) {
    width: 80%;
  }

  @media (max-width: 400px) {
    width: 90%;
  }
`;

export const HeaderModal = styled.h1`
  font-size: 30px;
  font-weight: 600;
  background-color: ${theme.color.charcoal};
  color: #ffffff;
  margin: 0;
  margin-top: -5px;
  padding: 15px 0;
  border-radius: 20px 20px 0 0;
  @media (max-width: 400px) {
    font-size: 25px;
  }
`;

export const HeaderDiv = styled.div`
  background-color: ${theme.color.charcoal};
  padding: 20px 20px 0 30px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const HeaderMessage = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${theme.color.pearl};
  margin: 0;
  padding-bottom: 25px;
  padding-top: -5px;
`;

export const BodyMessage = styled.p`
  font-size: 16px;
  font-weight: 400;
  padding: 20px 20px 0 30px;
  margin: 0;
  margin-top: 10px;
  margin-bottom: -10px;
`;

export const ButtonContainer = styled.div`
  margin: 25px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 30px 30px 0 30px;
`;

export const CrossContainer = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    cursor: pointer;
`;